import momentTZ from 'moment-timezone';

const exclude = [
  'cet',
  'cst6cdt',
  'cuba',
  'eet',
  'est',
  'est5edt',
  'egypt',
  'eire',
  'etc/gmt',
  'etc/gmt+0',
  'etc/gmt+1',
  'etc/gmt+10',
  'etc/gmt+11',
  'etc/gmt+12',
  'etc/gmt+2',
  'etc/gmt+3',
  'etc/gmt+4',
  'etc/gmt+5',
  'etc/gmt+6',
  'etc/gmt+7',
  'etc/gmt+8',
  'etc/gmt+9',
  'etc/gmt-0',
  'etc/gmt-1',
  'etc/gmt-10',
  'etc/gmt-11',
  'etc/gmt-12',
  'etc/gmt-13',
  'etc/gmt-14',
  'etc/gmt-2',
  'etc/gmt-3',
  'etc/gmt-4',
  'etc/gmt-5',
  'etc/gmt-6',
  'etc/gmt-7',
  'etc/gmt-8',
  'etc/gmt-9',
  'etc/gmt0',
  'etc/greenwich',
  'etc/uct',
  'etc/utc',
  'etc/universal',
  'etc/zulu',
  'gb',
  'gb-eire',
  'gmt',
  'gmt+0',
  'gmt-0',
  'gmt0',
  'greenwich',
  'hst',
  'hongkong',
  'iceland',
  'iran',
  'israel',
  'jamaica',
  'japan',
  'kwajalein',
  'libya',
  'met',
  'mst',
  'mst7mdt',
  'nz',
  'nz-chat',
  'navajo',
  'prc',
  'pst8pdt',
  'poland',
  'portugal',
  'roc',
  'rok',
  'singapore',
  'turkey',
  'uct',
  'utc',
  'universal',
  'w-su',
  'wet',
  'zulu',
];

const timezones = momentTZ.tz
  .names()
  .filter((timezone) => {
    const t = timezone.toLowerCase();

    return !exclude.includes(t);
  })
  .map((timezone) => {
    const zoneOffset = momentTZ.tz(new Date(), timezone).format('Z');

    return {
      label: timezone.replace(/_/g, ' '),
      zone: timezone,
      offset: zoneOffset,
    };
  });

const guessedTimezone = momentTZ.tz.guess();

export default timezones;
export { guessedTimezone };
